import { render, staticRenderFns } from "./PersonalCardTypeTable.vue?vue&type=template&id=2843061c&"
import script from "./PersonalCardTypeTable.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports